import { Theme } from '@mui/material';
import { styled } from '@mui/material/styles';

import AtomFlex from '../../../../components/atoms/AtomFlex';
import AtomGrid from '../../../../components/atoms/AtomGrid';
import IconComponent from '../../../../components/generics/IconComponent/IconComponent';
import { styleConfigs } from '../../../../components/resources/styleConfigs';
import palette from '../../../../theme/learnerPalette';

export const ContainerPage404Styled = styled(AtomFlex)(() => ({
  width: styleConfigs.dimensions.width100vw,
  height: styleConfigs.dimensions.height100vh,
  alignItems: 'center',
  justifyContent: 'center',
  background: '#F9FAFB',
  position: 'relative',
}));

export const ContainerNumberIconStyled = styled(AtomGrid)(({ theme }: { theme: Theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  placeContent: 'center',
  gap: styleConfigs.marginPadding.custom11,
  [theme.breakpoints.down('sm')]: {
    gap: styleConfigs.marginPadding.custom2,
  },
}));

export const EarthSearchStyled = styled(IconComponent)(({ theme }: { theme: Theme }) => ({
  height: styleConfigs.dimensions.width136,
  width: styleConfigs.dimensions.height136,
  [theme.breakpoints.down('sm')]: {
    height: styleConfigs.dimensions.width75,
    width: styleConfigs.dimensions.height75,
  },
}));

export const ContainerTitleStyled = styled(AtomGrid)(({ theme }: { theme: Theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  placeContent: 'center',
  gap: styleConfigs.marginPadding.custom12,
  [theme.breakpoints.down('sm')]: {
    marginBlockStart: styleConfigs.marginPadding.custom6,
    gap: styleConfigs.marginPadding.custom8,
  },
}));

export const ContainerButton = styled(AtomGrid)(({ theme }: { theme: Theme }) => ({
  background: palette.light.background.alabaster,
  marginTop: styleConfigs.marginPadding.custom58,
  borderRadius: styleConfigs.borders.radius8,
  [theme.breakpoints.down('sm')]: {
    marginTop: styleConfigs.marginPadding.custom36,
  },
}));
